import PersonSurveyBaseController from './person_survey_base_controller';

export default class extends PersonSurveyBaseController {
    connect() {
        super.connect?.();

        const form = document.querySelector('#survey-step-form-modal')
        if (!form) return;

        this.handleCurrentStep(form);
    }

    handleCurrentStep(form) {
        const step_class = Array.from(form.classList).find(c => c.startsWith('step-'));
        this.step = Number(step_class?.split('-')[1]);
        const handlers = {
            '5': () => this.handleStep5(),  // handled additionally by PersonSurveyTimeTable
            '6': () => this.handleStep6(),  // handled additionally by PersonSurveyTimeTable
        };

        handlers[this.step]?.();
    }

    handleStep5 = () => {}

    handleStep6 = () => requestAnimationFrame(this.setupTimeWishToggle)
}